var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  default: () => investmentsAdd_default
});
var import_constant = __toModule(require("./constant"));
var investmentsAdd_default = {
  id: "investments_add",
  isSummary: false,
  summaryId: "investments_summary",
  type: "radioCard",
  options: [
    {
      label: "Acciones",
      value: "C00011",
      imageUrl: `${import_constant.TAXDOWN_ASSETS_URL}/screen/investments/subsection_icon_acciones.png`
    },
    {
      label: "Cripto",
      value: "C00027",
      imageUrl: `${import_constant.TAXDOWN_ASSETS_URL}/screen/investments/subsection_icon_bitcoin_3.png`
    },
    {
      label: "Fondos y ETFs",
      value: "C00012",
      imageUrl: `${import_constant.TAXDOWN_ASSETS_URL}/screen/investments/subsection_icon_fondosdeinversion.png`
    },
    {
      label: "CFDs y futuros",
      value: "C00029",
      imageUrl: `${import_constant.TAXDOWN_ASSETS_URL}/screen/investments/subsection_icon_CFDs.png`
    },
    {
      label: "Intereses",
      value: "C00008",
      imageUrl: `${import_constant.TAXDOWN_ASSETS_URL}/screen/investments/subsection_icon_intereses.png`
    },
    {
      label: "Dividendos",
      value: "C00009",
      imageUrl: `${import_constant.TAXDOWN_ASSETS_URL}/screen/investments/subsection_icon_dividendos.png`
    },
    {
      label: "Derechos de suscripci\xF3n",
      value: "C00013",
      imageUrl: `${import_constant.TAXDOWN_ASSETS_URL}/screen/investments/subsection_icon_derechosdesuscripcion.png`
    },
    {
      label: "Seguros",
      value: "C00010",
      imageUrl: `${import_constant.TAXDOWN_ASSETS_URL}/screen/investments/subsection_icon_seguros.png`
    },
    {
      label: "Airdrops y Forks",
      value: "C00028",
      imageUrl: `${import_constant.TAXDOWN_ASSETS_URL}/screen/investments/subsection_icon_airdrop.png`
    },
    {
      label: "Otros",
      value: "C00014",
      imageUrl: `${import_constant.TAXDOWN_ASSETS_URL}/screen/investments/subsection_icon_otros.png`
    }
  ],
  validations: {
    required: false
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {});
